var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundE4Z(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1157 1158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M504.287 1004.77L522.114 986.95C537.014 972.124 557.184 963.8 578.209 963.8C599.235 963.8 619.404 972.124 634.305 986.95L651.99 1004.49L781.866 1134.3C793.011 1145.42 807.207 1152.98 822.656 1156.02C838.104 1159.06 854.109 1157.45 868.641 1151.4C883.173 1145.34 895.579 1135.1 904.285 1121.99C912.991 1108.87 917.605 1093.47 917.543 1077.73C917.603 1067.24 915.583 1056.84 911.601 1047.13C907.618 1037.43 901.752 1028.6 894.341 1021.17L634.73 762.535C627.324 755.062 618.509 749.129 608.796 745.08C599.083 741.032 588.663 738.947 578.139 738.947C567.614 738.947 557.195 741.032 547.481 745.08C537.768 749.129 528.954 755.062 521.548 762.535L262.22 1022.3C254.757 1029.7 248.848 1038.52 244.839 1048.23C240.831 1057.94 238.803 1068.36 238.876 1078.87C238.814 1094.6 243.428 1110.01 252.134 1123.12C260.84 1136.23 273.245 1146.47 287.778 1152.53C302.31 1158.59 318.315 1160.19 333.763 1157.15C349.211 1154.11 363.408 1146.55 374.553 1135.43L504.287 1004.77Z",
    fill: "url(#paint0_linear_1866_10009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.1 153.728L634.14 171.527C619.228 186.305 599.073 194.597 578.068 194.597C557.063 194.597 536.908 186.305 521.996 171.527L504.177 153.728L374.496 24.0458C363.356 12.9395 349.166 5.38727 333.724 2.34657C318.282 -0.694127 302.283 0.913606 287.757 6.96596C273.231 13.0183 260.831 23.2428 252.128 36.3432C243.426 49.4436 238.814 64.8301 238.876 80.5521V80.5521C238.803 91.0483 240.83 101.453 244.837 111.157C248.844 120.86 254.75 129.666 262.21 137.058L521.996 396.14C529.399 403.606 538.209 409.532 547.918 413.577C557.628 417.621 568.043 419.704 578.563 419.704C589.083 419.704 599.498 417.621 609.207 413.577C618.917 409.532 627.727 403.606 635.13 396.14L894.35 136.211C901.759 128.788 907.623 119.973 911.603 110.274C915.584 100.576 917.603 90.1863 917.543 79.7045C917.605 63.9825 912.992 48.596 904.29 35.4956C895.588 22.3952 883.188 12.1707 868.662 6.11837C854.135 0.0660114 838.137 -1.54172 822.695 1.49898C807.253 4.53968 793.063 12.0919 781.923 23.1982L652.1 153.728Z",
    fill: "url(#paint1_linear_1866_10009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.54 652.1L984.718 634.14C969.891 619.245 961.567 599.084 961.567 578.067C961.567 557.05 969.891 536.889 984.718 521.995L1002.25 504.459L1132.21 374.495C1143.32 363.355 1150.88 349.164 1153.93 333.722C1156.97 318.28 1155.36 302.282 1149.3 287.756C1143.25 273.23 1133.01 260.829 1119.9 252.127C1106.78 243.425 1091.38 238.812 1075.64 238.875C1065.15 238.822 1054.75 240.845 1045.05 244.825C1035.34 248.805 1026.52 254.665 1019.08 262.067L760.303 521.995C752.829 529.398 746.897 538.208 742.848 547.918C738.799 557.627 736.715 568.042 736.715 578.562C736.715 589.082 738.799 599.497 742.848 609.207C746.897 618.916 752.829 627.727 760.303 635.13L1020.07 894.35C1027.51 901.752 1036.33 907.612 1046.04 911.592C1055.74 915.572 1066.14 917.595 1076.63 917.543C1092.37 917.605 1107.77 912.992 1120.89 904.29C1134 895.588 1144.24 883.188 1150.29 868.661C1156.35 854.135 1157.96 838.137 1154.92 822.695C1151.87 807.253 1144.31 793.062 1133.2 781.922L1002.54 652.1Z",
    fill: "url(#paint2_linear_1866_10009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.614 504.459L171.45 522.278C186.291 537.172 194.624 557.333 194.624 578.35C194.624 599.367 186.291 619.528 171.45 634.422L153.756 652.1L23.2451 781.922C12.1163 793.062 4.54888 807.253 1.50203 822.695C-1.54482 838.137 0.0660986 854.135 6.1307 868.661C12.1953 883.187 22.4405 895.587 35.5674 904.29C48.6943 912.992 64.1119 917.604 79.8658 917.542C90.3687 917.602 100.78 915.583 110.498 911.603C120.216 907.622 129.048 901.758 136.486 894.35L396.092 634.564C403.573 627.161 409.512 618.35 413.564 608.641C417.617 598.932 419.704 588.516 419.704 577.996C419.704 567.477 417.617 557.061 413.564 547.352C409.512 537.643 403.573 528.832 396.092 521.429L136.486 262.067C129.048 254.659 120.216 248.795 110.498 244.814C100.78 240.834 90.3687 238.815 79.8658 238.875V238.875C64.1119 238.813 48.6943 243.425 35.5674 252.127C22.4405 260.83 12.1953 273.23 6.1307 287.756C0.0660986 302.282 -1.54482 318.28 1.50203 333.722C4.54888 349.164 12.1163 363.355 23.2451 374.495L153.614 504.459Z",
    fill: "url(#paint3_linear_1866_10009)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1866_10009",
    x1: 598.379,
    y1: 702.452,
    x2: 598.379,
    y2: 1115.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0DF",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A0DF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1866_10009",
    x1: 578.209,
    y1: 467.134,
    x2: 578.209,
    y2: 20.7032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0DF",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A0DF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1866_10009",
    x1: 1297.43,
    y1: 626.804,
    x2: 803.335,
    y2: 626.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#00A0DF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A0DF",
    stopOpacity: 0.42
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1866_10009",
    x1: 560.715,
    y1: 626.804,
    x2: 66.6197,
    y2: 626.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0DF",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A0DF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundE4Z);
export default __webpack_public_path__ + "static/media/background_e4z.4574817eec383ea6bbae5e0806b10f5d.svg";
export { ForwardRef as ReactComponent };